import React from 'react';
import card1 from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_name.webp";
import card2 from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_linkedin_id.webp";
import card3 from "../../../assets/illustrations2/PNG/homepage_search_method_by_decision_maker.png";

const cardData = [
  {
    title: "Bulk Search by Name",
    description: "Find and verify multiple email addresses using just names. Perfect for reaching many people at once.",
    icon: card1,
  },
  {
    title: "Bulk Search by LinkedIn ID",
    description: "Get email addresses directly from LinkedIn profiles. Just add profile IDs and we'll do the rest.",
    icon: card2,
  },
  {
    title: "Bulk Search by Decision Maker",
    description: "Locate key decision-makers and their verified email addresses to target the right people effectively.",
    icon: card3,
  },
];

const Card1 = () => {
  return (
    <div className="grid mb-4 md:mb-10 gap-6 sm:grid-cols-2 lg:grid-cols-3 p-6">
      {cardData.map((card, index) => (
        <div
          key={index}
          className={`bg-white shadow-lg rounded-lg flex flex-col text-left ${
            index === 2 ? 'sm:col-span-2 lg:col-span-1 sm:mx-auto' : ''
          }`}
        >
          <img
            src={card.icon}
            alt={`${card.title} icon`}
            className="mb-4 w-64 h-64 object-contain mx-auto"
          />
          <h3 className="text-xl px-6 pt-4 font-semibold mb-2">{card.title}</h3>
          <p className="text-gray-600 pt-2 px-6 mb-4">{card.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Card1;
